
const digest = 'a1b8cf85885de9a7f617a4900f9d85eace10d4b4dc1bc6e23f33a43697a1ed1e';
const classes = {"header":"_header_bf5ln_1","title":"_title_bf5ln_9"};
const css = `._header_bf5ln_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 21px 24px;
  border-bottom: 1px solid #e2e5ed;
}
._header_bf5ln_1 ._title_bf5ln_9 {
  font-size: 18px;
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  